<template>
<div>
<div class="mpart1">
  <div class="mpart1-1">
    <div class="mpart1-1Title">

        <img width="88" height="88" src="../assets/partners-icon.svg" alt="">
        <h1 class="mpart1Title">Партнеры</h1>
    </div>
    <p class="mpart1p">Наши клиенты могут быть уверены в том, что мы предлагаем наивысшее качество услуг и всегда стремимся предложить самые инновационные решения.</p>
    <p class="mpart1pp"> <span style="text-decoration:underline;"> <router-link  style="text-decoration: none; color:black;" to="Home"> Главная</router-link></span> / <span style="opacity:0.5;"> Производство</span></p>
  </div>    
</div>
<div class="mpart2">
    <!-- <div class="mpart2-0">
        <div class="mpart5left">Производство</div>
        <div class="mpart5leftLine"></div>
    </div> -->
    <div class="mpart2-1">
      <hr class="partner-line"/>
      <p class="partner-text">Мы дорожим нашей репутацией</p>
        <!-- <img style="margin-top:56px" src="../assets/img/mpart2icon.png" alt=""> -->
         <div class="mpart2-1Line-1"></div>
       
    </div>
    <div class="mpart2-2">
       <p class="partner-text-fitst">Мы верим в долговременные отношения и знаем, чтобы добиться этой цели, мы должны действовать как надежный партнер, всегда готовый оказать поддержку.</p>
    </div>
    <div class="mpart2-4 " style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/img/_01.png" alt="">
        <img src="../assets/img/001.png" class="fish"/>
    </div>
    <div class="mpart2-3 metal-text-second">
        <p class="partner-text-second">«MIMAR Group»</p>
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> Наше сотрудничество с MIMAR Group началось с первых дней её создания. Проектирование и строительство высокотехнологичных структур по всему миру - это страсть, которая движет каждым сотрудникам MIMAR Group.
Благодаря отлаженному производству, многолетнему опыту и сбалансированной ценовой политике мы стали одним из главных партнеров компании, которое вылелось в плодотворное сотрудничество. </p>   

    </div>
     <div class="mpart2-6 metal-text-second partner-text-chosh">
        <p class="partner-text-second">«Yangi Choshtepa»</p>
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> Yangi Choshtepa - это благоустроенный жилой комплекс для приверженцев спокойной, комфортной жизни вдали от городской суеты. </p>   

    </div>
    <div class="mpart2-5" style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/img/1pr.png" alt="">
        <img src="../assets/img/0202.png" class="fish"/>
    </div>
    <div class="mpart2-8" style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/img/011.png" alt="">
        <img src="../assets/img/011.1.png" class="fish"/>
    </div>
    <div class="mpart2-7 metal-text-second partner-text-chosh">
        <p class="partner-text-second">«Tashkent Сity» </p>
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> Международный деловой центр «Tashkent city» является одним из крупнейших градостроительных проектов, осуществляемых в Республике Узбекистан. </p>   

    </div>
    
     <div class="mpart2-10" style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/img/partner-1.png" alt="">
        <img src="../assets/img/partner-icon.png" class="fish"/>
    </div>
    <div class="mpart2-11 metal-text-second partner-text-chosh">
        <p class="partner-text-second"> «Discover lnvest»</p>
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> Компания Discover lnvest является одной из ведущих компаний на строительном рынке Узбекистана. За 1 О лет своего существования компания успешно реализовала "под ключ" более 70 архитектурных проектов. </p>   

    </div>
     <div class="mpart2-12 metal-text-second partner-text-chosh mt-5">
        <p class="partner-text-second"></p>
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p"> Компания Zhejiang Monle toys со., LTD. Расположена в китайском городе игрушек, Вэньчжоу, и занимается разработкой, производством и продажей коллекций внутри и снаружи помещений. Компания имеет выдающуюся техническую силу и экономическую базу в области разработки продуктов, совершенную систему управления, компания всегда стремится к качеству в своих продуктах. И поэтому мы выбрали её в качестве нашего партнера.  </p>   

    </div>
    <div class="mpart2-13" style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/img/partners-3.png" alt="">
        <img src="../assets/partners-icon-3.png" class="fish"/>
    </div>
    <div class="mpart2-14" style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/partners-2.png" alt="">
        <img src="../assets/partners-icon-2.png" class="fish"/>
    </div>
    <div class="mpart2-15 metal-text-second partner-text-chosh">
        <p class="partner-text-second">«Amadina»</p>
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p">Резиновые покрытия Amadina - это многофункциональные покрытия нового поколения, которые отлично сочетают в себе идеи инноваций, травмобезопасности, экологичности, создания удобного и комфортного пространства для жизни, спорта и отдыха. </p>   

    </div>

    <div class="mpart2-17" style="position: relative; left: 0; top: 0;">
        <img class="metal-pic decorative-image-2 fishes" src="../assets/partners-4.png" alt="">
        <img src="../assets/partners-icon-4.png" class="fish"/>
    </div>
    <div class="mpart2-16 metal-text-second partner-text-chosh">
        <p class="partner-text-second">«Заглушка.Ру» </p>
         <div class="mpart2-1Line"></div>
        <p class="mpart2-1p">Компания «Заглушка.Ру» успешно работает на рынке уже почти 30 лет! 
Она постоянно развиваемся и стремимся сделать сотрудничество с с ними максимально удобным на всех этапах работы. На данный момент она являемся крупнейшим производителем и поставщиком пластиковой фурнитуры, комплектующих для детских и спортивных площадок в России и СНГ. За годы успешной работы, компания завоевала отличную репутацию, зарекомендовала себя как надёжный деловой партнёр и ответственный производитель. </p>   

    </div>
    
</div>


<div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="mpart8Line"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h1 class="mpart8Title">
            Эффективные технологии и опыт специалистов позволяет 
            «METALIX» длостигать безупречного результата в сроки.
          </h1>
        </div>
      </div>
      <div class="row" style="padding: 0px">
        <div class="mpart8HideInfo col-md-1 col-sm-12">
          <div class="mpartInfoT">Проекты</div>
          <div class="mpart5leftLine-1"></div>
        </div>
        <div class="col-md-11 col-sm-12">
          <swiper class="swiper ml-3" id="CM" :options="swiperOptions">
            <swiper-slide>
              <div class="coverImgCarousel8">
                <!-- <img src="../assets/img/Home/image 288.png" /> -->
                <div class="carouselMain" style="">
                    <img style=" margin-right:5rem; color:white; z-index:24;"
                         class="home-icon"
                          src="@/assets/img/Home/2carousel/ico1.svg"
                          alt="section_2_bg_overlay"
                          
                        />
                        <div style=" z-index:33;width:80%"> 
                  <p class="part8mainTitle">
                 Строительство торгового центра.<br> Использование металлоконструкций в <br> каркасных технологиях.
                </p>
                <p class="part8mainTitlep">
                  «METALIX» предоставляет полный спектор услуг - от <br />
                  проектирования и производства металлоконструкций до
                  доставки<br />
                  на объекты и монтажа.
                </p>
                        </div>
                </div>
                
                
              </div></swiper-slide
            >
            <!-- <swiper-slide>
              <div class="coverImgCarousel8">
                <!- <img src="../assets/img/Home/image 288.png" /> ->
                <div class="part8mainTitle">
                 Строительство торгового центра <br> Использование металлоконструкций в <br>каркасных технологиях.
                </div>
                <p class="part8mainTitlep">
                  «METALIX» предоставляет полный спектор услуг - от <br />
                  проектирования и производства металлоконструкций до
                  доставки<br />
                  на объекты и монтажа.
                </p>
              </div></swiper-slide
            > -->

           
          </swiper>
          <div class="whiteBox">
            <div id="sppage"></div>
          </div>
        </div>
      </div>
    </div>
  

       <div class="mpart12" >
    
       <div class="mpart12-0Line"></div>
      <!-- </div> -->
      <div class="mpart12-1">
        <div class="mpart12-1Line"></div>
      </div>
      <div class="mpart12-2">
        <h4 class="mpart12-2Info">Обратная связь</h4>
        <div class="mpart12-2InfoLine"></div>
      </div>
     <div class="mpart12-3">
        <h1 class="mpart12-3T">
          Заполните форму обратной <br />
          связи и мы оперативно<br />
          свяжемся с вами !
        </h1>
      </div>
  <div class="mpart12-4">
       <b-form @submit="onSubmit" v-if="show" class="row" action="../../public/test.php"  method="POST">
      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="name"
          id="input-1"
          v-model="name"
          type="name"
          placeholder="Ваша имя"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="surname"
          id="input-2"
          v-model="surname"
          type="surname"
          placeholder="Ваша фамилия"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="email"
          id="input-3"
          v-model="email"
          type="email"
          placeholder="Ваша почта"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group  class="col-md-6 form-metalix">
        <b-form-input class="form-metalix-1" label="phone"
          id="input-4"
          v-model="phone"
          type="phone"
          placeholder="Ваш номер"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group  class="form-metalix">
        <b-form-input class="form-metalix-1" label="message"
          id="input-5"
          v-model="message"
          type="message"
          placeholder="Комментария"
          
        ></b-form-input>
      </b-form-group>
        <div style="display: flex; width:50%;">
          <input type="checkbox" checked  style="width:30px; height:50px; margin-right:3rem;">
          <p style="color:white;"> Я согласен на обработку<br/>персональных данных.  </p>
         
        </div>

      <b-button data-submit="...Sending" @click="showAlert" class="col-md-6 form-metalix-1 sending-btn" type="submit"  variant="primary">Отправить заявку</b-button>
    </b-form>
      </div>
      <div class="mpart12-5">
        <div class="mpart12TitleLine"></div>
        <p class="mpart12Tp">
          В разделе “комментарий” вы можете указать удобное для вас время когда
          мы можем с вами связаться.
        </p>
      </div>
      <div class="mpart12-6">
        <p class="mpart12Tp2">
          Мы не занимаемся рассылкой рекламных сообщений, а также не передаем
          контактные данные третьим лицам !
        </p>
      </div>
    </div>
    <div class="mpart13">
      <div class="mpart13-0">
        <div class="mpart13-0L"></div>
        <h4 class="mpart13-0T">Контакты</h4>
      </div>
      <!-- <div class="mpart13-1">
        <div class="mpart13-1Line"></div>
      </div> -->
      <div class="mpart13-2">
        <div class="row">
        <div class="col-12">
          <div class="mpart8Line" style="margin-left:0px;"></div>
        </div>
      </div>
        <h1 class="mpart13T">
          Мы благодарны Вам за проявленный интерес к нашей компании.
        </h1>
      </div>
      <div class="mpart13-3">
        <p class="mpart13Tp">
          Вы также можете получить консультацию по интересующим вас вопросам в
          любое время или приехать к нам в офис.
        </p>
      </div>
      <div class="mpart13-4">
        <div class="mpart13-4Line"></div>
        <div class="row partner-minisecton">
          <div class="col-sm-12 mpart13AdressInfo">
            <img
            width="24px" height="24px"
              class="mpart13AdresInfoimg"
              src="../assets/img/location.svg"
              alt=""
            />
            <ul class="mpart13-4Address">
              <li>г.Ташкент, Сергели</li>
              <li> ул.Нилуфар 77/7, 100155</li>
            </ul>
          </div>
          <div class="col-sm-12" style="display: flex">
            <img
            width="24px" height="24px"
              class="mpart13AdresInfoimg"
              src="../assets/img/phone.svg"
              alt=""
            />
            <ul class="mpart13-4PhoneUl">
              <li>+998 97 108 4444</li>
              <li>+998 97 109 4444</li>
            </ul>
          </div>
          <div class="col-sm-12" style="display: flex;">
            <img style="margin-top:15px;" width="24px" height="24px" src="../assets/img/mail.svg" alt="" />
            <p class="mpart13-4mailp">info@metalix.uz</p>
          </div>
          <div class="col-sm-12">
            <ul class="mpart13-4PhoneUl2">
              <li>По вопросам партнерства</li>
              <li>+998 90 334 35 00</li>
              <li>info@metalix.uz</li>
            </ul>
          </div>
          <!-- <div class="col-sm-12">
            <div class="socialTag" style="display: flex">
              <img class="part13icon" src="../assets/img/tgb.svg" alt="" />
              <p class="part13-4mailp2">Telegram</p>
            </div>
            <div class="socialn socialTag">
              <img class="part13icon" src="../assets/img/fbb.svg" alt="" />
              <p class="part13-4mailp2">Facebook</p>
            </div>
            <div class="socialn socialTag">
              <img class="part13icon" src="../assets/img/Inb.svg" alt="" />
              <p class="part13-4mailp2">Instagram</p>
            </div>
          </div> -->
        </div>
      </div>
      <div class="mpart13-5">
        <div class="mapouter">
          <div class="gmap_canvas">
          
          <iframe 
            class="gmap_iframe"
             
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2970.6581975340723!2d69.25022158783936!3d41.20638627079112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x702a9595707bb6f!2zNDHCsDEyJzIyLjkiTiA2OcKwMTUnMDguNyJF!5e0!3m2!1sru!2s!4v1636694271660!5m2!1sru!2s" width="100%" height="886" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            <!-- <iframe
              class="gmap_iframe"
              width="100%"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src="https://maps.google.com/maps?width=1112&amp;height=886&amp;hl=en&amp;q=tashkent&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              style="padding: 0 auto"
            ></iframe> -->
            <!-- https://goo.gl/maps/BcKh4QETzn99XK7E9 -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="mpart13">
      <div class="mpart13-0">
        <h4 class="mpart13-0T">Контакты</h4>
        <div class="mpart13-0L"></div>
      </div>
      <div class="mpart13-1">
        <div class="mpart13-1Line"></div>
      </div>
      <div class="mpart13-2">
        <h1 class="mpart13T">
          Мы благодарны Вам за проявленный <br />интерес к нашей компании.
        </h1>
      </div>
      <div class="mpart13-3">
        <p class="mpart13Tp">
          Вы также можете получить консультацию по интересующим вас вопросам в
          любое время или приехать к нам в офис.
        </p>
      </div>
      <div class="mpart13-4">
        <div class="mpart13-4Line"></div>
        <div style="display: flex; margin-top: 84px">
          <img src="../assets/img/location.svg" alt="" />
          <ul class="mpart13-4Address">
            <li>г.Ташкент, Сергели</li>
            <li>ул.Нилуфар 77/7, 100155</li>
          </ul>
        </div>
        <div style="display: flex">
          <img src="../assets/img/phone.svg" alt="" />
          <ul class="mpart13-4PhoneUl">
             <li>+998 97 108 4444</li>
              <li>+998 97 109 4444</li>
          </ul>
        </div>
        <div style="display: flex; margin-top: 40px">
          <img src="../assets/img/mail.svg" alt="" />
          <p class="mpart13-4mailp">info@metalix.uz</p>
        </div>
        <div>
          <ul class="mpart13-4PhoneUl2">
            <li>По вопросам партнерства</li>
            <li>+998  90 334 35 00</li>
            <li>info@metalix.uz</li>
          </ul>
        </div>
        <div style="display: flex">
          <img class="mpart13icon" src="../assets/img/tgb.svg" alt="" />
          <p class="mpart13-4mailp2">Telegram</p>
        </div>
        <div style="display: flex; margin-top: 16px">
          <img class="mpart13icon" src="../assets/img/fbb.svg" alt="" />
          <p class="mpart13-4mailp2">Facebook</p>
        </div>
        <div style="display: flex; margin-top: 16px">
          <img class="mpart13icon" src="../assets/img/Inb.svg" alt="" />
          <p class="mpart13-4mailp2">Instagram</p>
        </div>
      </div>
      <div class="mpart13-5">
        <div class="mapouter">
          <div class="gmap_canvas">
            <iframe
              class="gmap_iframe"
              width="100%"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src="https://maps.google.com/maps?width=1112&amp;height=886&amp;hl=en&amp;q=tashkent&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            ></iframe>
          </div>
        </div>
      </div>
    </div> -->
   
</div>
</template>
<script>

import Swal from "sweetalert2";
import { directive } from "vue-awesome-swiper";
import axios from 'axios';
import "swiper/swiper-bundle.css";
export default {
  data() {
      return {
        form: {
          name: '',
          surname: '',
          email: '',
          phone: '',
          message: '',
        },
        // foods: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
        show: true,
      }
    },
    methods: {
      onSubmit(event) {
        event.preventDefault()
        let data = new FormData(); 
    
 
    data.append('name', this.name) 
    data.append('surname', this.surname) 
    data.append('email', this.email) 
    data.append('phone', this.phone) 
    data.append('message', this.message)
    console.log(data)
        axios.post('../../public/test.php', data)

    .then((data) => {Swal.fire({
  position: 'center',
  icon: 'success',
  iconColor: 'red',
  title: 'Отправлено !',
  showConfirmButton: false,
  timer: 1500
});console.log(data)})
    .catch(error => {

       
        console.error('There was an error!', error);
        this.$swal('Error');
    });
      },
      


      showAlert(){
			
  
 
  
			
		},
    },
   components: {
    // VueSlickCarousel,
    // Carousel, Slide
   
  },
  directives: {
    swiper: directive,
  }, 
      mounted () {
  window.scrollTo(0, 0)
}


}
</script>
<style scoped>
.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
  background: #fbfbfb;
  color: black;
  width: 456px;
  height: 120px;
  margin-bottom: -4px;
  margin-left: 0px;
}

.swiper-pagination-fraction {
  /* color: red !important; */
  padding-top: 50px;
  /* border: 1px solid red; */
}
.mpart13AdresInfoimg {
  margin-top: 45px;
  /* width: 40px;
  height: 40px; */
}
.mpart13AdressInfo {
  display: flex;
  margin-top: 84px;
}
.mpart13AdresInfoimg {
  margin-top: 45px;
  /* width: 40px;
  height: 40px; */
}
.form-metalix {
  margin-bottom: 5rem;
}
.form-metalix-1{
  height: 80px;
}
.sending-btn{
  width: 425px;
  margin-left: 15px !important;
  background-color: white;
  border: none;
  font-family: Styrene A LC;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #272a2e;
}
.mpart1{
   display: grid;
  grid-template-columns: 232px 1fr 384px;
  grid-auto-rows: minmax(472, auto);
   background: #fbfbfb;  
}
.swiper-button-prev, .swiper-button-next{
  color: white !important;
}
.mpart1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.mpart1-1Title{
  margin-left: -2rem;
    display: flex;
    justify-content: left;
    margin-top: 96px;
}
.mpart1Title{
height: 88px;
font-family: Inter;
font-style: normal;
font-weight: bold;
font-size: 64px;
line-height: 88px;
/* identical to box height, or 137% */
margin-left: 64px;
letter-spacing: 0.015em;
text-transform: uppercase;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart1p{
  margin-left: -2rem;
    height: 80px;
    margin-top: 40px;
    margin-bottom:192px !important;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 500;
font-size: 24px;
line-height: 40px;
/* or 167% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}

.mpart1-1{
  height: 330px;
}
.mpart1pp{
    height: 120px;
    margin-top: -9rem;
    margin-bottom: 30px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 40px;
/* or 167% */
margin-left: -2rem;
letter-spacing: 0.1em;
text-indent: 0px;
/* metalix (ligtt,text) */

color: #36454F;
}
.coverImgCarousel8 {
  position: relative;
  /* display: inline-block; */
  width: 100%;
  height: 776px;
  background-image: url("../assets/partner-img.png");
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.coverImgCarousel8::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background: -moz-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* FF3.6+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* Opera 11.10+ */
  background: -ms-radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* IE10+ */
  background: radial-gradient(
    83.12% 398.5% at 79.31% 100%,
    rgba(35, 59, 87, 0) 0%,
    #233b57 100%
  ); /* W3C */
  /* filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#002f4b', endColorstr='#00000000',GradientType=0 );  */
  /* rgba(35, 59, 87, 0) 0%,
    #233b57 100% */
  /* ); */
  mix-blend-mode: normal;
  opacity: 0.48;
}
.carouselMain{
position:absolute; 
display:flex;
width: 100%;
height: 100%;
 justify-content:space-evenly;
 align-items: flex-start;
 padding: 15vh 5vw;
}
.mpart8Line {
  width: 120px;
  height: 1px;
  margin-left: 170px;
  margin-top: 108px;
  margin-bottom: 99px;
  background: #b4c0cf;
}
.mpart8Margin {
  margin-bottom: 40px;
  margin-top: 40px;
}
.mpart8Title {
  width: 80%;
  height: 96px;
  margin-bottom: 104px;
  margin-left: 172px;
  margin-right: 32px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  text-indent: 32px;

  /* metalix (ligtt,text) */

  color: #36454f;
}

.mpart8mainTitle {
  text-align: left;
  position: fixed;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 88px;
  /* or 137% */
  z-index: 5;
  width: 1000px;
  margin-top: -630px;
  margin-left: 152px;

  letter-spacing: 0.015em;
  text-transform: uppercase;

  /* _Text */

  color: #fbfbfb;
}

.part8mainTitlep {
    position: absolute;
    width: 696px;
    height: 112px;
    text-align: left;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 40px;
    z-index: 51;
    letter-spacing: 0.1em;
    /* text-shadow: 0px 1px 2px #000; */
    color: #fbfbfb;
}
.part8mainTitle {
  text-align: left;
  /* position: fixed; */
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 64px;
  /* or 137% */
  z-index: 33;
  max-width: 80%;
  letter-spacing: 0.015em;
  text-shadow:  0px 1px 1px black;
  /* _Text */

  color: #fbfbfb;
}
 .mpart8mainTitlep {
    position: absolute;
    width: 240px;
    height: 168px;
    left: 16px;
    top: 370px;
    z-index: 1;
    color: #fbfbfb !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
.mpart2
{
    display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.mpart2-1 {
  grid-column: 2/4;
  grid-row: 1/2;
  text-align: left;
}
.mpart2-2 {
  grid-column: 5/7;
  grid-row: 1/2;
}
.mpart2-3 {
  grid-column: 2/4;
  grid-row: 2/3;
  margin-top: 10rem;
}
.mpart2-4 {
  grid-column: 5/7;
  grid-row: 2/3;
  text-align: left;
  margin-top: 4rem;
}
.mpart2-5 {
  grid-column: 2/4;
  grid-row: 3/3;

}
.mpart2-6 {
  grid-column: 5/7;
  grid-row: 3/3;
}
.mpart2-7 {
  grid-column: 2/4;
  grid-row: 4/4;
  margin-top: 32px;
}
.mpart2-8 {
  grid-column: 5/7;
  grid-row: 4/4;
  text-align: left;
  margin-top: 32px;
}

.mpart2-10 {
  grid-column: 2/4;
  grid-row: 5/5;
  /* margin-top: 10rem; */
}
.mpart2-11 {
  grid-column: 5/7;
  grid-row: 5/5;
  text-align: left;
  margin-top: 10rem;
}
.mpart2-12 {
  grid-column: 2/4;
  grid-row: 6/6;

}
.mpart2-13 {
  grid-column: 5/7;
  grid-row: 6/6;
}
.mpart2-14 {
  grid-column: 2/4;
  grid-row: 7/7;
  /* margin-top: 32px; */
}
.mpart2-15 {
  grid-column: 5/7;
  grid-row: 7/7;
  text-align: left;
  margin-top: 32px;
}
.mpart2-16 {
  grid-column: 2/4;
  grid-row: 8/8;
  margin-top: 32px;
}
.mpart2-17 {
  grid-column: 5/7;
  grid-row: 8/8;
  text-align: left;
  /* margin-top: 32px; */
}

.mpart2-9 {
  grid-column: 4/8;
  grid-row: 9/9;

}
.mpart2-1Line{
 width: 700px;
height: 1px;
margin-top: 64px;
/* line (darck) */
margin-bottom: 39px;
background: #B4C0CF;
}
.mpart2-1Line-1{
margin-top: 64px;
/* line (darck) */
margin-bottom: 39px;
width: 330px;
height: 4px;
background: #233B57;
}
.mpart2-1p{
    width: 696px;
    height: 120px;
text-align: left;

font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 18px;
line-height: 40px;
/* or 222% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart5leftLine {
  width: 164px;
  height: 2px;
  margin-top: 180px;
  margin-left: 18px;
  background: #272a2e;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart5leftLine-1 {
  width: 172px;
  height: 2px;
  margin-top: 180px;
  margin-left: 0px;
  background: #272a2e;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart5left {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}

.inputMar {
 margin-left:152px;
  /* margin-right: 36px; */
}
/************part8  ****************/

.mpart8 {
  display: grid;
  grid-template-columns: 200px 2fr 0.5fr 0.5fr 0.5fr;
  grid-auto-rows: minmax(472, auto);
  background: #ffffff;
}
.mpart8-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart8-1 {
  grid-column: 1/2;
  grid-row: 3/4;
  display: block;
}

.mpart8-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}

.mpart8-3 {
  grid-column: 4/5;
  grid-row: 2/2;
}

.mpart8-4 {
  grid-column: 5/6;
  grid-row: 2/2;
}

.mpart8-5 {
  grid-column: 2/6;
  grid-row: 3/4;
}
.mpart8InfoLine {
  width: 164px;
  height: 2px;
  right: -151px;
  bottom: -2px;

  /* metalix (ligtt,text) */

  background: #36454f;
  transform: rotate(-90deg);
}
.mpartInfoT {
  width: 170px;
  height: 24px;

  margin-top: 150px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* metalix (ligtt,text) */

  color: #36454f;

  transform: rotate(-90deg);
}
#part8carousel .VueCarousel-navigation-next{
    
    z-index: 4 !important;
    margin-right: 135px !important;
    margin-top: -530px !important;
}
#part8carousel .VueCarousel-navigation-prev{
   
    margin-top: -530px !important;
    margin-left: 1365px !important;
    z-index: 4 !important;
}
/***********part 8 end */
/**************part12 */
.mpart12 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.mpart12-0 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart12-1 {
  grid-column: 5/6;
  grid-row: 1/2;
}
.mpart12-2 {
  grid-column: 1/2;
  grid-row: 1/7;
}
.mpart12-3 {
  grid-column: 2/4;
  grid-row: 2/3;
}
.mpart12-4 {
  grid-column: 5/5;
  grid-row: 2/5;
}
.mpart12-5 {
  grid-column: 2/4;
  grid-row: 3/4;
}
.mpart12-6 {
  grid-column: 2/4;
  grid-row: 4/6;
}
.mpart12TitleLine {
  width: 392px;
  height: 4px;
  margin-top: 96px;
  margin-bottom: 76px;
  /* _Light */

  background: #fbfbfb;
}
.fishes
    {
      position: relative;
      top: 0;
      left: 0;
      /* width: 100%; */
    }
    .fish
    {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 250px;
      height: 250px;
    }
    .partner-text-chosh{
      margin-top: 5rem;
    }
.mpart12Tp {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12Tp2 {
  width: 392px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-top: 72px;
  margin-bottom: 104px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12-0Line {
  width: 120px;
  height: 2px;
  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */
  margin-left: 0;
  background: #fbfbfb;
}
.partner-line{
  width: 120px;
  margin-bottom: 6rem;
  margin-top: 8rem;
}
.mpart12-1Line {
  width: 880px;
  height: 2px;

  margin-top: 108px;
  margin-bottom: 99px;
  /* _Light */

  background: #fbfbfb;
  opacity: 0.16;
}
.mpart12-2Info {
  margin-top: 300px;
  width: 247px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* line (darck) */

  color: #b4c0cf;

  transform: rotate(-90deg);
}
.mpart12-2InfoLine {
  width: 164px;
  height: 2px;
  margin-top: 190px;
  margin-left: 43px;
  background: #4b5a64;
  /* line */

  box-shadow: inset 1px 0px 0px #36454f;
  transform: rotate(-90deg);
}
.mpart12-3T {
  width: 543px;
  height: 144px;
  margin-top: 0;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.mpart12Checkp {
  width: 310px;
  height: 48px;
  text-align: left;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  margin-left: 50px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
#mpart12Check {
  width: 32px;
  height: 32px;
  background-color: #36454f !important;
  /* Light (darck) 02 */

  border: 1px solid #9dafbc;
  box-sizing: border-box;
  border-radius: 1.5px;
}
.mpart12InfoBT {
  font-family: Styrene A LC;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  text-align: center;
  letter-spacing: 2px;
  text-transform: uppercase;

  /* Metalix_darck */

  color: #272a2e;
}
.mpart12InfoLine {
  width: 880px;
  height: 1px;
  margin-bottom: 63px;
  /* _Light */

  background: #fbfbfb;
  opacity: 0.16;
}
.mpart12InfoMust {
  width: 532px;
  height: 24px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  margin-top: 40px;
  margin-bottom: 104px;
  margin-left: 15px;
  letter-spacing: 0.1em;

  /* _Light */

  color: #fbfbfb;
}
.partner-text-fitst{
  font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 40px;
/* or 222% */
margin-top: 14rem;
text-align: left;
letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
.mpart12InfoButton {
  width: 392px;
  height: 80px;

  background: #cfd3d6;
  box-shadow: 0px 4px 32px #575d65;
}

.mpart12Infotextarea{
  background: white;
  /* _Light */
  margin-top: 48px;
  margin-left: 0px !important;
  margin-bottom: 46px;
  width: 850px !important;
  height: 80px;
  border: 1px solid #fbfbfb;
  box-sizing: border-box;
  resize: none;
}
.partner-text{
  font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 42px;
line-height: 64px;
/* or 114% */

letter-spacing: 0.1em;

/* metalix (ligtt,text) */

color: #36454F;
}
#fname {
  width: 392px;
  height: 64px;

  /* _Light */

  background: #fbfbfb;
  /* _Light */

  border: 1px solid #fbfbfb;
  box-sizing: border-box;
}
.partner-text-second{
  font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 48px;
/* identical to box height, or 150% */
display: flex;
letter-spacing: 0.05em;

/* metalix (ligtt,text) */

color: #36454F;
}
/****************part12 end*/
/*****part 13 */
.mpart13 {
  display: grid;
  grid-template-columns: 200px 1fr 1fr 1fr 1fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart13-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.mpart13-1 {
  grid-column: 2/4;
  grid-row: 1/2;
}
.mpart13-2 {
  grid-column: 2/4;
  grid-row: 2/2;
}
.mpart13-3 {
  grid-column: 5/7;
  grid-row: 2/3;
}
.mpart13-4 {
  grid-column: 2/4;
  grid-row: 3/3;
}
.mpart13-5 {
  grid-column: 4/8;
  grid-row: 3/3;
}
.mpart13-4Line {
  width: 392px;
  height: 4px;

  /* _Text */

  background: #233b57;
}
.mpart13icon {
  margin-top: -15px;
}
.mpart13-4Address {
  width: 336px;
  height: 48px;
  margin-top: 35px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-4PhoneUl2 {
  width: 336px;
  height: 96px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  /* or 200% */
  margin-left: 28px;
  list-style-type: none;
  letter-spacing: 0.15em;
  margin-bottom: 105px;
  margin-top: 88px;
  /* active(bottom) */

  color: #d19258;
}
.mpart13-4mailp2 {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  margin-left: 28px;
  /* margin-top: 15px; */
  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-4mailp {
  width: 336px;
  height: 24px;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: left;
  letter-spacing: 0.15em;
  margin-left: 30px;
  /* Text */

  color: #233b57;
}
.mpart13-4PhoneUl {
  width: 336px;
  height: 72px;
  margin-top: 45px;
  text-align: left;
  list-style-type: none;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.15em;

  /* Text */

  color: #233b57;
}
.mpart13-0T {
  width: 89px;
  height: 24px;
  margin-top: 15px;
  margin-left: 36px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  /* identical to box height, or 200% */

  letter-spacing: 0.25em;
  text-transform: uppercase;

  /* _Text */

  color: #233b57;

  transform: rotate(-90deg);
}
.mpart13-0L {
  width: 164px;
  height: 2px;
  margin-top: 150px;
  margin-bottom: 200px;
  /* _Text */

  background: #233b57;
  transform: rotate(-90deg);
}
.mpart13-1Line {
  width: 120px;
  height: 1px;
  margin-top: 108px;
  margin-bottom: 99px;

  background: #b4c0cf;
}
.mpart13T {
  width: 715px;
  height: 96px;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  /* or 150% */

  letter-spacing: 0.1em;
  margin-top: 0px;
  margin-bottom: 96px;
  /* Text */

  text-align: left;
  color: #233b57;
}
.mpart13Tp {
  width: 696px;
  height: 80px;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 40px;
  /* or 222% */
  margin-top: 13rem;
  letter-spacing: 0.1em;
  text-indent: 32px;

  /* Text */

  color: #233b57;
}
/***********part 13 end */
/******part 14 *****/
.part14 {
  display: grid;
  grid-template-columns: 200px 1fr 0.5fr 1fr 0.5fr;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.part14-0 {
  grid-column: 1/2;
  grid-row: 3/3;
}
.part14-1 {
  grid-column: 2/3;
  grid-row: 2/2;
  display: flex;

}
.part14-2 {
  grid-column: 4/5;
  grid-row: 2/2;
    display: flex;
}
.part14-3 {
  grid-column: 2/3;
  grid-row: 3/3;
    display: flex;
}
.part14-4 {
  grid-column: 4/5;
  grid-row: 3/3;
    display: flex;
}
.part14-5 {
  grid-column: 2/3;
  grid-row: 4/4;
    display: flex;
}

.part14-6 {
  grid-column: 4/5;
  grid-row: 4/4;
    display: flex;
}
.part14-8 {
  grid-column: 2/5;
  grid-row: 1/2;
}
.part14Line{
width: 1672px;
height: 1px;
left: 200px;
top: 3600px;
margin-bottom:127px ;
margin-top: 96px;
/* line (darck) */

background: #B4C0CF;
}
.part14h1{
width: 100%;
height: 32px;
left: 176px;
top: 8px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 32px;
/* identical to box height, or 133% */

letter-spacing: 0.1em;

/* metalix (ligtt,text) */

color: #36454F;
}
.part14p{
  margin-top: 40px;
  margin-bottom: 112px;
  width: 544px;
height: 96px;
left: 176px;
top: 80px;
text-align: left;
font-family: Inter;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 32px;
/* or 200% */

letter-spacing: 0.1em;
text-indent: 24px;

/* metalix (ligtt,text) */

color: #36454F;
}
/******part 14 end */
/****part15 */
.part15 {
  display: grid;
  grid-template-columns: 200px 1fr ;
  grid-auto-rows: minmax(1136, auto);
  background: #F2F6F5;
}
.part15-0{
  grid-column: 1/2;
  grid-row: 1/2;
}

.part15-1{
  grid-column: 2/3;
  grid-row: 1/2;
}
.part15Line{
  width: 384px;
height: 2px;
margin-top: 287px;
    margin-left: -95px;

/* metalix (ligtt,text) */

background: #36454F;
/* line */

box-shadow: inset 1px 0px 0px #36454F;
transform: rotate(-90deg);
}
.part15h1{
  text-align: left;
  margin-top: 144px;
  margin-bottom: 112px;
  margin-left: 150px;
  width: 1152px;
height: 224px;
left: 384px;
top: 4704px;

font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 56px;
/* or 175% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
/****part15 end*/
/* iPads (portrait and landscape) ----------- */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) {
  .mpart13T{
    margin-top: 5em;
  }
  .part15h1{
    width: 700px !important;
    height: 16em !important;
    font-size: 20px !important;
  }
  .mpart2-1MiniB{
    display: block;
  }
  .mpart1{
   display: grid;
  grid-template-columns: 15vw 1fr 384px;
  grid-auto-rows: minmax(472, auto);
   background: #fbfbfb;  
}
.mpart1-1 {
  grid-column: 2/3;
  grid-row: 1/2;
}
.mpart1Title{
  font-size: 32px;
}
.mpart1p{
  width: 635px;
  height: 180px;
}
/*****part 2 */
.mpart2
{
    display: grid;
  grid-template-columns: 5vw 1fr 5vw;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart2-0 {
 display: none;
}
.mpart2-1 {
  grid-column: 2/2;
  grid-row: 1/2;
  text-align: left;
}
.mpart2-2 {
  grid-column: 2/2;
  grid-row: 2/2;
}
.mpart2-3 {
  grid-column: 2/2;
  grid-row: 3/3;
  margin-top: 32px;
}
.mpart2-4 {
  grid-column: 2/2;
  grid-row: 4/4;
  text-align: left;
  margin-top: 32px;
}
.mpart2-5 {
  grid-column: 2/2;
  grid-row: 5/5;

}
.mpart2-6 {
  grid-column: 2/2;
  grid-row: 6/6;
}
.mpart2-7 {
  grid-column: 2/2;
  grid-row: 7/7;
  margin-top: 32px;
}
.mpart2-8 {
  grid-column: 2/2;
  grid-row: 8/8;
  text-align: left;
  margin-top: 0px;
}
.mpart2-9 {
  grid-column: 2/2;
  grid-row: 9/9;

}
.decorative-image-2{
  width: 30em;
  height: 30em;
}
.mpart2-1p{
  height: 15em;
}
/****part 14 */
.part14 {
  display: grid;
  grid-template-columns:5vw 1fr 5vw;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.part14-0 {
 display: none;
}
.part14-1 {
  grid-column: 2/2;
  grid-row: 2/2;
  display: flex;

}
.part14-2 {
  grid-column: 2/2;
  grid-row: 3/3;
    display: flex;
}
.part14-3 {
  grid-column: 2/2;
  grid-row: 4/4;
    display: flex;
}
.part14-4 {
  grid-column: 2/2;
  grid-row: 5/5;
    display: flex;
}
.part14-5 {
  grid-column: 2/2;
  grid-row: 6/6;
    display: flex;
}

.part14-6 {
  grid-column: 2/2;
  grid-row: 7/7;
    display: flex;
}
.part14-8 {
  grid-column: 2/2;
  grid-row: 8/8;
}
.part14Line{
  width: 700px;
}
/****part15 */
.part15 {
  display: grid;
  grid-template-columns: 5vw 1fr 5vw ;
  grid-auto-rows: minmax(1136, auto);
  background: #F2F6F5;
}
.part15-0{
  display: none;
}

.part15-1{
  grid-column: 2/2;
  grid-row: 1/2;
}
.part15Line{
  width: 184px !important;
height: 2px;
margin-top: 287px;
margin-left: -70px;

/* metalix (ligtt,text) */

background: #36454F;
/* line */

box-shadow: inset 1px 0px 0px #36454F;
transform: rotate(-90deg);
}
.part15h1{
  text-align: left;
  margin-top: 144px;
  margin-bottom: 112px;
  margin-left: 0px;
  width: 600px;
height: 224px;
left: 384px;
top: 4704px;

font-family: Inter;
font-style: normal;
font-weight: 600;
font-size: 26px;
line-height: 56px;
/* or 175% */

letter-spacing: 0.1em;
text-indent: 32px;

/* metalix (ligtt,text) */

color: #36454F;
}
/**** */
.mpart8Title{
  width: 80vw;
  font-size: 26px;
  height: 10rem;
}
.mpart8mainTitle{
  width:65vw;
  font-size: 26px;
}
/******part13 */
/*****part 13 */
.mpart13 {
  display: grid;
  grid-template-columns: 5vw 1fr 5vw;
  grid-auto-rows: minmax(1136, auto);
  background: #fbfbfb;
}
.mpart13-0 {
  display: none;
}
.mpart13-1 {
  grid-column: 2/2;
  grid-row: 1/1;
}
.mpart13-2 {
  grid-column: 2/2;
  grid-row: 2/2;
}
.mpart13-3 {
  grid-column: 2/2;
  grid-row: 3/3;
}
.mpart13-4 {
  grid-column: 2/2;
  grid-row: 4/4;
}
.mpart13-5 {
  grid-column: 2/2;
  grid-row: 5/5;
}
/*****part12 */
.mpart12 {
  display: grid;
  grid-template-columns: 2vw 1fr 5vw;
  grid-auto-rows: minmax(1136, auto);
  background: #36454f;
}
.mpart12-0 {
  grid-column: 2/2;
  grid-row: 1/1;
}
.mpart12-1 {
  grid-column: 2/2;
  grid-row: 2/2;
}
.mpart12-2 {
  display: none;
}
.mpart12-3 {
  grid-column: 2/2;
  grid-row: 3/3;
}
.mpart12-4 {
  grid-column: 2/2;
  grid-row: 4/4;
}
.mpart12-5 {
  grid-column: 2/2;
  grid-row: 5/5;
}
.mpart12-6 {
  grid-column: 2/2;
  grid-row: 6/6;
}
.mpart12-1Line{
  width: 700px;
  margin-top: 0px;
}
#fname[data-v-ed6a348c] {
    width: 292px;
    height: 64px;
    background: #fbfbfb;
    border: 1px solid #fbfbfb;
    box-sizing: border-box;
}
.inputMar{
  margin-left: 90px;
}
.mpart12Infotextarea{
  width: 630px !important;
  margin-left: -85px !important;
  margin-right: 0px !important;
}
.mpart12InfoLine{
  width: 700px !important;
}
.mpart12InfoButton{
  width: 300px;
}
.mpart2-1Line{
  width: 650px;
}
.mpart8HideInfo {
  display: none;
}
}

@media (min-width: 1367px) and (max-width: 1440px) {
  .mpart8Title{
    width: 800px;
  }
  .mpart12-3T{
    font-size: 24px;
  }
   .sending-btn{
    width: 400px;
  }
  .mpart1p{
    height: 150px !important;
  }
  .mpart2-1Line{
    margin-top: 5px;
    width: 100%;
    margin-bottom: 20px;
  }
  .mpart12InfoLine{
    width: 830px;
    margin-left: 10px;
  }
  .mpart12-1Line{
    width: 835px;
  }
  .mpart13-2{
    grid-column: 1/4;
    margin-left: 40px;
}
.mpart1{
    grid-template-columns: 200px 1fr 384px;
}
.mpart2{
    grid-template-columns: 165px 1fr 1fr 1fr 1fr 1fr 0.5fr;
}
.mpart12InfoButton{
  margin-left: 10px;
}
.mpart13T{
  width: 100%;
}
.mpart13Tp{
  width: 100%;
}
.mpart13-4{
  grid-column: 1/4;
    margin-left: 40px;
}
  .mpart13-0{
    display: none;
  }
  .partner-text{
    font-size: 34px;
  }
  .mpart12InfoLine{
    margin-left: 10px;
  }
  .decorative-image-2{
    width: 562px;
  }
  .mpart2-1p{
    width: 562px;
  }
  .mpart2{
    padding-bottom: 10rem;
  }
  .mpart8Title{
    width: 80%;
    margin-left: 155px;
  }
  .mpart8Line{
    margin-left: 155px;
  }
  .part8mainTitle{
    font-size: 36px;
  }
  .mpart12-2{
    display: none;
  }
  .mpart12-3{
    grid-column: 1/4;
    grid-row: 2/3;
    margin-left: 40px;
}
.mpart12-0Line{
  margin-left: 40px;
}
.mpart12-5{
    grid-column: 1/4;
    margin-left: 40px;
}
.mpart12-6{
  grid-column: 1/4;
  margin-left: 40px;
}
}
/* Desktops and laptops  1280-----------@media only screen and (max-width: 1280px) { old */
@media (min-width: 1025px) and (max-width: 1280px) {
   .mpart2-1Line{
     margin-top: 5px;
   }
  .mpart12InfoLine{
    width: 780px;
  }
  .mpart8Title{
    width: 1200px;
  }
  .mpart1p{
    height: 150px;
  }
  .mpart12Infotextarea{
    width: 42.1em !important;
    margin-left: -45px !important;
  }
}




@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  /* Styles */
   .sending-btn{
    width: 340px !important;
    margin-left: 28px !important;
}
.form-metalix-1{
  width: 340px !important;
  margin-left: 17px;
}
.checking{
  display: none;
}
  .mpart1p{
    width: 100% !important;
  }
  .mpart13-4PhoneUl2{
    width: 300px;
  }
  .mpart13 {
    display: grid;
    grid-template-columns: 16px 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #fbfbfb;
  }
  .mpart13-0 {
    grid-column: 2/3 !important;
    grid-row: 1/2 !important;
    display: flex !important;
    width: 80%;
  }
  .mpart13-1 {
    display: none;
  }
  .mpart13-2 {
    grid-column: 2/3 !important;
    grid-row: 3/3 !important;
    width: 300px;
  }
  .mpart13-3 {
    display: none;
  }
  .mpart13-4 {
    grid-column: 2/3 !important;
    grid-row: 5/5 !important;
    width: 90%;
  }
  .mpart13-5 {
    display: none;
  }

  .mpart13T {
    width: 328px;
    height: 96px;
    margin-left: 0px;
    margin-bottom: 40px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */
    letter-spacing: 0.05em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .mpart13-4Line {
    width: 240px;
    height: 4px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .mpart13AdressInfo {
    margin-top: 36px;
  }
  .part13-4PhoneUl2 {
    margin-left: 0px;
  }
  .mmapouter {
    height: 184px;
  }
  .gmap_canvas {
    height: 184px;
  }
  .gmap_iframe {
    width: 375px;
  }
  .mpart13-4Address {
    width: 240px !important;
    height: 48px;
  }
  .mpart13-0T {
    width: 61px;
    height: 16px;
    margin-left: 24px;
    margin-top: 32px;
    margin-bottom: 32px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    letter-spacing: 2px;

    /* metalix (ligtt,text) */

    color: #36454f;
    transform: none;
  }
  .mpart13-0L {
    width: 64px;
    height: 1px;
    margin-left: 0px;
    margin-top: 39px;
    margin-bottom: 0px;
    transform: none;
    background: #b4c0cf;
  }
  .mpart1 {
    display: block;
    grid-template-columns: 30px 1fr 384px;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
}
.mpart1-1Title {
    display: flex;
    justify-content: left;
    margin-top: 0;
    margin-left: 2rem;
}
.mpart1-1Title img{
  margin-top: 3rem;
}
.mpart1-1Title h1{
  margin-top: 4.1rem;
  margin-left: 2rem;
}
.mpart2{
  display: block !important;
  padding-left: 30px;
  margin-top: 14rem;
}
.partner-line{

}
.mpart1pp{
  margin-bottom: 0;
}
.fishes{
  width: 100%;
}
.mpart1Title{
  font-size: 30px;
  line-height: 40px;
  margin-top: 3rem;
  margin-left: 0;
}
.mpart1-1 .mpart1p{
  margin-left: 2rem;
  font-size: 20px;
  width: 90% !important;
}
  .mpart1pp{
    margin-top: 21rem;
    margin-left: 2rem;
    width: 90%;
  }
  .three-btn-callback{
    margin-top: 0rem !important;
  }
  .part2item-2 .middle-section-pr{
    margin-top: -2rem !important;
  }
  .part1Margin{
    margin-left: 0;
  }
  .partner-text{
    margin-top: 9rem !important;
    font-size: 30px;
  }
  .partner-text-fitst{
    margin-top: 0;
    margin-right: 1rem;
  }
  .mpart2-7{
    margin-bottom: 15rem;
  }
  .mpart2-11{
    margin-bottom: 11rem;
  }
  .mpart2-12 {
    margin-bottom: 37rem;
  }
  .mpart2-15{
    margin-bottom: 23rem;
  }
  .mpart2-5, .mpart2-8, .mpart2-10, .mpart2-13, .mpart2-14, .mpart2-17{
    margin-left: -2rem !important;
  }
  .mpartInfoT, .mpart5leftLine-1{
    display: none;
  }
  .mpart8Title{
    margin-left: 30px;
    margin-top: 31rem;
    margin-bottom: 18rem;
    font-size: 24px;
    width: 90%;
  }
  .mpart2-6{
    margin-top: 42rem;
    margin-bottom: 10rem;
  }
  .mpart2-1Line{
    width: 100%;
  }
  .mpart2-1p{
    width: 95%;
  }
  .mpart2-3 {
    margin-top: 4rem !important;
  }
  .mpart2-4 {
    margin-left: -2rem;
  }
  .part2line-1{
    display: none;
  }
  .carouselMain{
    display: block;
  }
  .home-icon{
    width: 35%;
    margin-left: -6.5rem;
    margin-bottom: 1rem;
  }
  .whiteBox{
    display: none;
  }
  .inputMar {
    margin-left: 0px;
  }
  #fname {
    margin-top: 40px;
    width: 300px !important;
    margin-left: 0px !important;
  }
  .mt-5{
    margin-top: 0 !important;
  }
  .row > * {
    flex-shrink: 0;
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    margin-top: 0;
  }
  .container,
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    margin-right: 0;
    margin-left: 0;
  }
  .row {
    --bs-gutter-x: 0rem;
  }
  .swiper-pagination {
    display: none;
  }
  .swiper-button-next {
    display: none;
  }
  .swiper-button-prev {
    display: none;
  }
  .part1Colum {
    display: none;
  }
  .mainTitle {
    width: 328px;

    height: 160px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    /* or 125% */
    z-index: 3;
    text-transform: uppercase;

    /* _Text */

    color: #fbfbfb;
  }
  .mainTitlep {
    position: absolute;
    width: 240px;
    height: 168px;
    left: 16px;
    
    z-index: 1;
    color: #fbfbfb !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
  .part8mainTitle {
    width: 328px;

    height: 160px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 40px;
    /* or 125% */
    z-index: 3;
    text-transform: uppercase;
    margin-bottom: 2rem;
    /* _Text */

    color: #fbfbfb;
  }
  .part8mainTitlep {
    position: absolute;
    width: 240px;
    height: 168px;
    left: 40px;
    z-index: 1;
    color: #fbfbfb !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-top: 4rem;
  }
  .project-line{
    display: none;
  }
  .fish{
    width: 100px;
    height: 100px;
  }
  .part1 {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(480px, auto);
  }

  .mainImgc {
    width: 100%;
    height: 480px;
  }
  .mobileHide {
    display: none;
  }
  .part4about {
    /* text-align: center; */
    width: 100%;
    height: 16px;
    left: 88px;
    top: 0px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;

    /* identical to box height, or 160% */
    letter-spacing: 2px;
    /* identical to box height, or 200% */
    margin-left: 16px;
    /* text-transform: uppercase; */

    /* line (darck) */

    color: #b4c0cf;

    transform: rotate(0deg);
  }
  .mpart12 {
    display: grid;
    grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .mpart12-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .mpart12-1 {
    grid-column: 1/2 !important;
    grid-row: 2/2 !important;
  }
  .mpart12-2 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
    display: flex !important;
  }
  .mpart12-3 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .mpart12-4 {
    grid-column: 1/2 !important;
    grid-row: 5/5 !important;
  }
  .mpart12-5 {
    grid-column: 1/2 !important;
    grid-row: 6/6 !important;
  }
  .part12-6 {
    grid-column: 1/2 !important;
    grid-row: 7/7 !important;
  }
  .row {
    max-width: 100% !important;
  }
  .mpart12Infotextarea {
    width: 300px !important;
    margin-left: 38px !important;
    margin-bottom: 35px;
  }
  .mpart12InfoLine {
   display: none;
   /* width: 328px !important;
    margin-left: 0px !important; */
  }
  .mpart12InfoButton {
    width: 300px !important;
    margin-left: 0px !important;
    margin-bottom: 4rem;
  }
  .mpart8Line{
    display: none;
  }
  .mpart12Margin{
    display: none !important;
  }
  .mpart12InfoMust {
    width: 80% !important;
    height: 48px;
    margin-left: 16px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .mpart12-3T {
    width: 328px !important;
    height: 128px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .mpart12-0 {
    display: none;
  }

  .mpart12-1 {
    display: none;
  }
  .mpart12-2InfoLine {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;
    transform: none;
    background: #8fa1ac;
  }
  .mpart12-2Info {
    transform: none;
    width: 120px;
    height: 16px;
    margin-left: 24px !important;
    margin-top: 32px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    letter-spacing: 2px;

    /* _Light */

    color: #fbfbfb;
  }
  .mpart12-3T {
    width: 328px;
    height: 128px;
    margin-left: 16px;
    top: 7728px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .mpart12InfoLine {
    width: 240px !important;
    height: 4px !important;
    margin-left: 16px !important;

    /* _Light */

    background: #fbfbfb !important;
  }
  .mpart12Checkp {
    width: 240px;
    height: 48px;
    margin-left: 56px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  #mpart12Check {
    margin-left: 16px;
  }
  .mpart12-5 {
    display: none;
  }
  .mpart12Tp2 {
    width: 288px !important;
    height: 96px;
    margin-left: 40px;
    top: 8576px;

    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    letter-spacing: 0.15em;

    /* _Light */

    color: #fbfbfb;
  }
  .mpart12-0Line{
    margin-left: 30px;
  }
  .part4rec {
    width: 64px;
    height: 2px;
    background: #fcfdff;
    /* line */
    margin-top: -9px;
    margin-bottom: 80px;
    box-shadow: inset 1px 0px 0px #36454f;
    transform: rotate(0deg);
  }
  /******Part2 */
  .part2Title {
    /* position: absolute; */
    width: 328px;
    height: 96px;
    margin: 32px 16px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;

    /* or 133% */
    letter-spacing: 0.05em;

    /* metalix (ligtt,text) */
    color: #36454f;
  }
  .part2Title2 {
    width: 240px;
    height: 240px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    margin-top: 0;
    letter-spacing: 0.15em;
    text-indent: 32px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .project-text{
    margin-top: 0 !important;
  }
  .part2 {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(0px, auto);
  }
  .part2-0 {
    grid-column: 1/2;
    grid-row: 1/2;
    display: flex;
  }

  .part2item-1 {
    grid-column: 1/2;
    grid-row: 2/2;
  }

  .part2item-2 {
    grid-column: 1/2;
    grid-row: 3/3;
  }
  .part2line {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;

    background: #b4c0cf;
  }
  .part2aboutline {
    width: 153px;
    height: 16px;
    margin-left: 24px;
    margin-top: 32px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;

    /* identical to box height, or 160% */
    letter-spacing: 2px;

    /* metalix (ligtt,text) */
    color: #B4C0CF;
  }
  .mpart12-6{
    display: none;
  }

  .mpart13-2 .col-12{
    width: 300px;
  }
  /*****part3 */
  .part3 {
    display: grid;
    /* grid-gap: 1rem !important; */
    /* grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important; */
    grid-template-columns:16px 1fr 16px !important;
    grid-auto-rows: minmax(254px, auto);
  }
  .part3-0 {
    grid-column: 2/2;
    grid-row: 1/2;
    display: flex;
  }
  .part3-1 {
    display: none;
    /* grid-column: 1/2;
  grid-row: 2/2; */
  }
  .part3about {
    margin-top: 0px;
    transform: none;
    /* display: none; */
  }
  .part3Line {
    margin-top: 0px;
    transform: none;
    /* display: none; */
  }
  .part3-2 {
    grid-column: 2/2;
    grid-row: 3/3;
  }
  .part3-5 {
    grid-column: 2/2;
    grid-row: 4/4;
  }
  .infoBlock h3 {
    width: 240px;
    height: 48px;
    margin-right: 36px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;

    /* or 150% */
    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */
    color: #36454f;
  }
  .infoBlock img {
    width: 52px;
    height: 48px;
    margin-left: 16px;
    margin-top: -90px;
  }
  .infoBlockP {
    width: 90%;
    min-height: 200px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    margin-top: 4px;
    margin-left: 8px;
    letter-spacing: 0.15em;
    text-indent: 24px;
  }
  /******part4 */
  .part4 {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #272d31;
  }
  .part4-1 {
    grid-column: 1/2;
    grid-row: 1/2;
  }
  .part4-2 {
    grid-column: 1/2;
    grid-row: 2/2;
  }

  .part4-3 {
    grid-column: 1/2;
    grid-row: 3/3;
  }
  .part4-4 {
    grid-column: 1/2;
    grid-row: 4/4;
  }

  .part4-5 {
    grid-column: 1/2;
    grid-row: 5/5;
  }
  .part4-6 {
    grid-column: 1/2;
    grid-row: 6/6;
  }
  .part4h {
    width: 328px;
    height: 160px;
    margin-left: 16px;
    margin-top: 32px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.1em;

    /* _Light */
    color: #fbfbfb;
  }
  .part4h3 {
    width: 328px;
    height: 48px;
    margin-bottom: 32px;
    margin-top: 0px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    text-align: left;
    margin-left: 16px;
    margin-right: 16px;
    letter-spacing: 0.15em;
    text-indent: 24px;
  }
  .part4-4 {
    display: none;
  }

  .part4-5 {
    display: none;
  }

  /***part5 */
  .part5line1 {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;

    background: #8fa1ac;
  }
  .part5 {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(20ch, 1fr)) !important;
    /* grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(720, auto) !important; */
    background: #f2f6f5;
  }
  .part5-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .part5-1 {
    /* grid-column: 1/2;
    grid-row: 2/2; */
    display: none !important;
  }

  .part5-2 {
    grid-column: 1/2 !important;
    grid-row: 2/3 !important;
  }

  .part5-3 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
  }

  .part5-4 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .part5-5 {
    grid-column: 1/2 !important;
    grid-row: 5/5 !important;
  }
  .part5Title {
    width: 328px;
    height: 168px !important;
    margin-left: 16px !important;
    margin-top: 32px !important;
    margin-bottom: 40px !important;
    font-family: Inter !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    /* or 150% */

    letter-spacing: 0.1em !important;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part5Line {
    width: 240px !important;
    height: 4px !important;
    margin-top: 0px !important;
    margin-bottom: 0px;
    margin-left: 16px;
  }
  .part5MiniBlockP {
    margin-left: 16px !important;
  }
  .part5MiniBlockT {
    width: 240px;
    height: 48px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  .part5MiniBlockP {
    width: 328px;
    height: 120px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.15em;
    text-indent: 24px;
  }
  .minipart5-4 img {
    width: 52px;
    height: 48px;
    display: block;
    /* text-align: left; */
    margin-left: 125px;
    margin-bottom: 50px;
  }
  /************part6 */
  .part6InfoLine {
    display: none;
  }
  .part6Info {
    width: 237px;
    height: 16px;

    margin: 0px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */
    margin-top: 32px;
    letter-spacing: 2px;

    /* metalix (ligtt,text) */
    transform: none;
    color: #36454f;
  }
  .part6Line {
    margin: 0;
    display: none;
  }
  .part6Title {
    width: 228px;
    height: 64px;
    margin-left: 0px;
    margin-top: 80px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part6Line {
    width: 192px;
    height: 4px;
    margin-bottom: 108px;
    /* _Text */

    background: #233b57;
  }
  .part6 {
    display: grid;
    grid-template-columns: 16px 1fr !important;
    grid-auto-rows: minmax(472, auto);
    background: #fbfbfb;
  }
  .part6-0 {
    grid-column: 2/2;
    grid-row: 1/2;
  }
  .part6-1 {
    /* display: flex; */
    grid-column: 1/2;
    grid-row: 1/4;
  }

  .part6-2 {
    grid-column: 2/2;
    grid-row: 2/2;
  }

  .part6-3 {
    grid-column: 2/2;
    grid-row: 3/3;
  }

  .part6-4 {
    grid-column: 2/2;
    grid-row: 4/4;
    text-align: left;
  }
  .part6-5 {
    grid-column: 2/2;
    grid-row: 5/5;
    text-align: left;
  }
  .part6-6 {
    grid-column: 2/2;
    grid-row: 6/6;
    text-align: left;
  }
  .part6-7 {
    grid-column: 2/2;
    grid-row: 7/7;

    text-align: left;
  }
  .part6-8 {
    grid-column: 2/2;
    grid-row: 8/8;

    text-align: left;
  }
  .part6P {
    width: 328px;
    height: 96px;
    margin-right: 16px !important;
    margin-left: 0px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    margin-top: 5px;
    margin-bottom: 50px;
    letter-spacing: 0.15em;
    text-indent: 24px;
  }
  .part6-4 img {
    width: 52px;
    height: 48px;
  }
  .part6-5 img {
    width: 52px;
    height: 48px;
  }
  .part6-6 img {
    width: 52px;
    height: 48px;
  }
  .part6-7 img {
    width: 52px;
    height: 48px;
  }
  .part6-8 img {
    width: 52px;
    height: 48px;
  }
  .part6BlockTitle {
    width: 240px;
    height: 48px;
    margin-top: 16px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part6BlockP {
    width: 240px;
    height: 120px;

    margin-top: 0px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.15em;
    text-indent: 24px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  /*****part7 */

  .part7 {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important;
    /* grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(772, auto); */
    background: #272d31;
  }
  .part7-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .part7-1 {
    grid-column: 1/2 !important;
    grid-row: 2/2 !important;
  }

  .part7-2 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
  }

  .part7-3 {
    grid-column: 1/2 !important;
    grid-row: 8/8 !important;
  }

  .part7-4 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .part7-5 {
    grid-column: 1/2 !important;
    grid-row: 9/9 !important;
  }
  .part7-6 {
    grid-column: 1/2 !important;
    grid-row: 6/6 !important;
    margin-bottom: 72px;
  }
  .part7-7 {
    grid-column: 1/2 !important;
    grid-row: 7/7 !important;
  }
  .part7-6 img {
    width: 355px;
    height: 316px;
    margin-left: 0px !important;
  }
  .part7-7 img {
    width: 355px;
    height: 316px;
    margin-left: 0px !important;
  }
  .part7Button {
    width: 70%;
    margin-top: 90px;
    margin-bottom: 50px;
    margin-left: 0px !important;
  }
  .part7BI {
    display: none;
  }
  .part7P2 {
    width: 90% !important;
    height: 120px;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */
    margin-top: 32px;
    margin-left: 16px !important;
    letter-spacing: 0.15em;
    text-indent: 24px;

    /* _Light */

    color: #fbfbfb;
  }
  .part7P {
    width: 328px;
    height: 120px;
    margin-left: 16px !important;
    margin-bottom: 0px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.15em;
    text-indent: 24px;

    /* _Light */

    color: #fbfbfb;
  }
  .part7Title {
    width: 328px !important;
    height: 64px;
    margin-left: 16px !important;
    /* margin-right: 16px !important; */
    margin-top: 40px !important;

    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part7Line {
    width: 64px;
    height: 1px;
    margin-left: 16px;

    margin-top: 39px;
    background: #8fa1ac;
  }
  .part7Button {
    margin: 120px 16px 40px 16px;
  }

  /*****Part 8*******/
  .part8 {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(472, auto);
    background: #ffffff;
  }
  .part8-0 {
    grid-column: 1/2;
    grid-row: 1/2;
  }
  .part8-1 {
    grid-column: 1/2;
    grid-row: 2/2;
    display: block;
  }

  .part8-2 {
    grid-column: 1/2;
    grid-row: 3/3;
  }

  .part8-3 {
    grid-column: 1/2;
    grid-row: 4/4;
  }

  .part8-4 {
    grid-column: 1/2;
    grid-row: 5/5;
  }

  .part8-5 {
    grid-column: 1/2;
    grid-row: 6/6;
  }
  .part8Title {
    width: 328px;
    height: 96px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    letter-spacing: 0.1em;
    margin-left: 16px !important;
    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part8InfoLine {
    display: none;
  }
  .partInfoT {
    width: 56px;
    height: 16px;
    left: 88px;
    top: 0px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    letter-spacing: 2px;

    /* metalix (ligtt,text) */
    transform: rotate(0deg);
    color: #36454f;
  }
  .mainImgc {
    width: 360px;
    height: 424px;
  }
  .carouselImg {
    width: 360px;
    height: 424px;
  }
  .part8Line {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;
    margin-bottom: 32px;
    background: #b4c0cf;
  }
  .part8HideInfo {
    display: none;
  }
  /****part11 *****/
  .part11 {
    display: grid;
    grid-gap: 1rem !important;
    grid-template-columns: repeat(auto-fit, minmax(2ch, 1fr)) !important;
    /* grid-template-columns:16px 1fr 16px !important;
    grid-auto-rows: minmax(1136, auto); */
    background: #fafafa;
    margin-top: 0px !important;
  }
  .part11Date {
    display: none;
  }
  .part11Date2 {
    display: none;
  }
  .partInfoLine {
    width: 64px;
    height: 1px;

    margin-top: 39px;
    margin-left: 16px;
    background: #b4c0cf;
  }
  .part11Title {
    width: 328px !important;
    height: 128px !important;
    margin-left: 0px !important;
    margin-bottom: 40px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part11BTitle {
    width: 252px;
    height: 72px;
    margin-left: 16px;
    /* top: 6864px; */
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    letter-spacing: 0.1em;
    text-decoration-line: underline;

    /* _Text */

    color: #233b57;
  }
  .part11BTitle2 {
    width: 252px;
    height: 72px;
    /* top: 6864px; */
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */
    margin-bottom: 0px !important;
    letter-spacing: 0.1em;
    text-decoration-line: underline;
    margin-left: 16px;
    /* _Text */

    color: #233b57;
  }
  .part115Img img {
    width: 328px;
    height: 376px;
  }
  .part11Imargin {
    margin-top: 0px;
  }
  .part11B {
    width: 344px;
  }
  .part11BP {
    width: 328px;
    height: 176px;

    margin-top: 24px;
    margin-left: 16px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.1em;
    text-indent: 24px;

    /* _Text */

    color: #233b57;
  }
  .part11Line {
    display: none;
  }
  .part11Info {
    width: 63px;
    height: 16px;
    margin-left: 24px;
    margin-top: 32px;
    margin-bottom: 32px;
    transform: none;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    letter-spacing: 2px;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part11InfoLine {
    /* position: absolute; */
    width: 64px;
    height: 10px;
    margin-top: 39px;
    margin-left: 0px;
    background: #b4c0cf;
  }
  .part11BlockLine {
    width: 152px;
    height: 1px;
    margin-left: 16px;

    background: #b4c0cf;
    opacity: 0.32;
  }
  .part11BlockLine2 {
    width: 152px;
    height: 1px;
    margin-left: 16px;

    background: #b4c0cf;
    opacity: 0.32;
  }
  .part11-0 {
    display: none;
  }
  .part11-1 {
    grid-column: 2/3 !important;
    grid-row: 1/2 !important;
    display: flex;
  }
  .part11-2 {
    grid-column: 2/3 !important;
    grid-row: 2/2 !important;
  }
  .part11-3 {
    grid-column: 2/3 !important;
    grid-row: 3/3 !important;
  }
  .part11-4 {
    grid-column: 2/3 !important;
    grid-row: 4/4 !important;
  }

  .part11-5 {
    grid-column: 2/3 !important;
    grid-row: 5/5 !important;
  }
  .part11-6 {
    grid-column: 2/3 !important;
    grid-row: 6/6 !important;
  }
  .part11-7 {
    grid-column: 2/3 !important;
    grid-row: 7/7 !important;
  }

  .part11-8 {
    grid-column: 2/3 !important;
    grid-row: 8/8 !important;
  }
  /*****part12-4*****/
  .part12 {
    display: grid;
    grid-template-columns: 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #36454f;
  }
  .part12-0 {
    grid-column: 1/2 !important;
    grid-row: 1/2 !important;
  }
  .part12-1 {
    grid-column: 1/2 !important;
    grid-row: 2/2 !important;
  }
  .part12-2 {
    grid-column: 1/2 !important;
    grid-row: 3/3 !important;
    display: flex !important;
  }
  .part12-3 {
    grid-column: 1/2 !important;
    grid-row: 4/4 !important;
  }
  .part12-4 {
    grid-column: 1/2 !important;
    grid-row: 5/5 !important;
  }
  .part12-5 {
    grid-column: 1/2 !important;
    grid-row: 6/6 !important;
  }

  .row {
    max-width: 100% !important;
  }
  .part12Infotextarea {
    width: 80% !important;
    margin-left: 40px !important;
    margin-bottom: 35px;
  }
  .part12InfoLine {
   display: none;
   /* width: 328px !important;
    margin-left: 0px !important; */
  }
  .part12InfoButton {
    width: 300px !important;
    margin-left: 0px !important;
  }
  .part12Margin{
    display: none !important;
  }
  .part12InfoMust {
    width: 80% !important;
    height: 48px;
    margin-left: 16px !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    /* or 200% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part12-3T {
    width: 328px !important;
    height: 128px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part12-0 {
    display: none;
  }

  .part12-1 {
    display: none;
  }
  .part12-2InfoLine {
    width: 64px;
    height: 1px;
    margin-left: 16px;
    margin-top: 39px;
    transform: none;
    background: #8fa1ac;
  }
  .part12-2Info {
    transform: none;
    width: 120px;
    height: 16px;
    margin-left: 24px !important;
    margin-top: 32px;
    margin-bottom: 32px;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    letter-spacing: 2px;

    /* _Light */

    color: #fbfbfb;
  }
  .part12-3T {
    width: 328px;
    height: 128px;
    margin-left: 16px;
    top: 7728px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  .part12InfoLine {
    width: 240px !important;
    height: 4px !important;
    margin-left: 16px !important;

    /* _Light */

    background: #fbfbfb !important;
  }
  .part12Checkp {
    width: 240px;
    height: 48px;
    margin-left: 56px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    letter-spacing: 0.1em;

    /* _Light */

    color: #fbfbfb;
  }
  #part12Check {
    margin-left: 16px;
  }
  .part12-5 {
    display: none;
  }
  .part12Tp2 {
    width: 288px !important;
    height: 96px;
    margin-left: 40px;
    top: 8576px;

    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    /* or 171% */

    letter-spacing: 0.15em;

    /* _Light */

    color: #fbfbfb;
  }
  /**part13 */
  /************part13 */
  .part13 {
    display: grid;
    grid-template-columns: 16px 1fr !important;
    grid-auto-rows: minmax(1136, auto);
    background: #fbfbfb;
  }
  .part13-0 {
    grid-column: 2/3 !important;
    grid-row: 1/2 !important;
    display: flex !important;
  }
  .part13-1 {
    display: none;
  }
  .part13-2 {
    grid-column: 2/3 !important;
    grid-row: 3/3 !important;
  }
  .part13-3 {
    display: none;
  }
  .part13-4 {
    grid-column: 2/3 !important;
    grid-row: 5/5 !important;
  }
  .part13-5 {
    display: none;
  }

  .part13T {
    width: 328px;
    height: 96px;
    margin-left: 0px;
    margin-bottom: 40px;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */
    letter-spacing: 0.05em;

    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part13-4Line {
    width: 240px;
    height: 4px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .part13AdressInfo {
    margin-top: 36px;
  }
  .part13-4PhoneUl2 {
    margin-left: 0px;
  }
  .mapouter {
    height: 184px;
  }
  .gmap_canvas {
    height: 184px;
  }
  .gmap_iframe {
    width: 375px;
  }
  .part13-4Address {
    width: 240px !important;
    height: 48px;
  }
  .part13-0T {
    width: 61px;
    height: 16px;
    margin-left: 24px;
    margin-top: 32px;
    margin-bottom: 32px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    letter-spacing: 2px;

    /* metalix (ligtt,text) */

    color: #36454f;
    transform: none;
  }
  .part13-0L {
    width: 64px;
    height: 1px;
    margin-left: 0px;
    margin-top: 39px;
    margin-bottom: 0px;
    transform: none;
    background: #b4c0cf;
  }
  /*** part11*/
  .part11Title {
    width: 80%;
    height: 128px;

    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */

    letter-spacing: 0.1em;
    margin-left: 16px !important;
    margin-right: 16px;
    margin-bottom: 40px;
    /* metalix (ligtt,text) */

    color: #36454f;
  }
  .part13-4PhoneUl {
    width: 308px;
  }
  .part13-4mailp {
    width: 228px;
  }
  .part13-4PhoneUl2 {
    width: 328px;
  }
  .socialTag {
    width: 328px;
  }
  .project-text{
    font-size: 22px;
    margin-top: 3rem !important;
    padding-right: 1rem;
    margin-left: 2rem;
  }
  .part2Title2{
    margin-left: 2rem;
    width: 300px;
    height: 40px;
  }
  .part2Title2{
    margin-bottom: 11rem;
  }
}




/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* Styles **/
  .mpart12Infotextarea{
    width: 600px !important;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  .mpart12Infotextarea{
  background: white;
  /* _Light */
  margin-top: 48px;
  margin-left: 0px !important;
  margin-bottom: 46px;
  width: 830px !important;
  height: 80px;
  border: 1px solid #fbfbfb;
  box-sizing: border-box;
  resize: none;
}
}
</style>